module.exports = __webpack_public_path__ + "static/media/4.39524cd4.ogg";